import React from 'react';
import classNames from 'classnames';
import LayoutContainer from '../../LayoutContainer';
import ToggleSection from '../../ToggleSection';
import './styles.css';

const UrlList = ({
  title,
  columns = 2,
  subTitle,
  data,
  renderItem = () => {},
  toggleData,
  className,
  maxWidth,
  embedTitle,
}) => {
  if (data && !!data.length)
    return (
      <div
        className={classNames('Landing__UrlList__root', {
          [className]: className,
        })}
      >
        {!embedTitle && (
          <LayoutContainer>
            <div>
              <h2 className="Landing__UrlList__title">{title}</h2>
              {subTitle && (
                <h3 className="Landing__UrlList__subTitle">{subTitle}</h3>
              )}
            </div>
          </LayoutContainer>
        )}

        <LayoutContainer style={{ maxWidth: maxWidth || '1200px' }}>
          <div className="Landing__UrlList__content">
            {embedTitle && (
              <div>
                <h2 className="Landing__UrlList__title">{title}</h2>
                {subTitle && (
                  <h3 className="Landing__UrlList__subTitle">{subTitle}</h3>
                )}
              </div>
            )}
            <ul className="Landing__UrlList__list">
              {data.map((item, key) => (
                <li
                  key={key.toString()}
                  style={{
                    width: `${100 / columns}%`,
                  }}
                >
                  {renderItem(item)}
                </li>
              ))}
            </ul>
            {toggleData && !!toggleData.length && (
              <ToggleSection
                moreText="Show More"
                lessText="Show Less"
                parentSelector=".Landing__UrlList__content"
              >
                <ul className="Landing__UrlList__list">
                  {toggleData.map((item, key) => (
                    <li
                      key={key.toString()}
                      style={{
                        width: `${100 / columns}%`,
                      }}
                    >
                      {renderItem(item)}
                    </li>
                  ))}
                </ul>
              </ToggleSection>
            )}
          </div>
        </LayoutContainer>
      </div>
    );
  return '';
};

export default UrlList;
